
const MAX_TOTAL_SIZE = 25 * 1024 * 1024 // 25MB in bytes

function CONTROL_OF_FILES(files) {
  let valid = true
  for (let i = 0; i < files.length; i++) {
    const element = files[i]
    if (!element.type.includes('pdf') && !element.type.includes('image') && !element.type.includes('video'))
      valid = false
  }
  return valid
}

export default {
  data() {
    return {
      isDragging: false,
      fileList: [],
      alert: {
        show: false,
        message: '',
        variant: '',
      },
    }
  },

  computed: {
    totalSize() {
      return this.fileList.reduce((total, file) => total + file.size, 0)
    }
  },

  methods: {
    showAlert(message, variant) {
      this.alert = {
        show: true,
        message,
        variant,
      }
      setTimeout(() => {
        this.alert.show = false
      }, 5000)
    },

    checkTotalSize(newFiles) {
      const newTotalSize = this.totalSize + newFiles.reduce((sum, file) => sum + file.size, 0)
      if (newTotalSize > MAX_TOTAL_SIZE) {
        this.showAlert('Total file size exceeds 25MB limit', 'error')
        return false
      }
      return true
    },

    formatBytes(bytes, decimals = 2) {
      if (!+bytes) return '0 Bytes'

      const k = 1024
      const dm = decimals < 0 ? 0 : decimals
      const sizes = ['Bytes', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']

      const i = Math.floor(Math.log(bytes) / Math.log(k))

      return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
    },

    REMOVE_FROM_LIST(i) {
      this.fileList.splice(i, 1)
    },

    GET_DROP_ITEM(e) {
      e.preventDefault()
      this.isDragging = false
      const files = e.dataTransfer.files
      if (files.length > 5) {
        this.showAlert('Maximum 5 files allowed', 'error')
        return
      }

      if (!CONTROL_OF_FILES(files)) {
        this.showAlert('Only PDF, image and video files are allowed', 'error')
        return
      }

      if (!this.checkTotalSize(Array.from(files))) return

      this.$refs.file.files = files
      this.UPLOAD_FILES(files)
    },

    SET_FILES(e) {
      const files = e.target.files
      if (!this.checkTotalSize(Array.from(files))) {
        e.target.value = '' // Reset input
        return
      }
      this.UPLOAD_FILES(files)
    },

    UPLOAD_FILES(files) {
      if (files.length === 0) return
      if (this.fileList.length + files.length > 5) {
        this.showAlert('Maximum 5 files allowed', 'error')
        return
      }
      this.fileList = [...this.fileList, ...Array.from(files)]
      this.$emit('response:file', files)
    },
  },
}
